import cn from 'classnames';
import React, { forwardRef } from 'react';

interface Props {
    isChecked?: boolean;
    onCheckChange?: (isChecked: boolean) => void;
    isDisabled?: boolean;
    label: string;
    labelClassName?: string;
    id: string;
    name?: string;
    value?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const CheckBoxGradient = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const {
        isChecked = false,
        onCheckChange,
        isDisabled = false,
        label,
        labelClassName = '',
        id,
        name,
        value,
        onChange,
        onBlur
    } = props;
    // Đơn giản hóa: xác định checked state
    const isControlledByForm = onChange !== undefined;
    const checked = isControlledByForm ? Boolean(value) : Boolean(isChecked);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newChecked = e.target.checked;

        if (isControlledByForm && onChange) {
            // Cho react-hook-form
            onChange(e);
        } else if (onCheckChange) {
            // Cho backward compatibility
            onCheckChange(newChecked);
        }
    };

    return (
        <div className="w-full h-full flex flex-row justify-center items-start gap-2">
            <div className="relative">
                <input
                    ref={ref}
                    id={id}
                    name={name}
                    type="checkbox"
                    data-testid="checkbox-gradient"
                    className="sr-only"
                    checked={checked}
                    onChange={handleChange}
                    onBlur={onBlur}
                    disabled={isDisabled}
                />
                <label
                    htmlFor={id}
                    className={cn(
                        "h-[24px] w-[24px] rounded-md border-2 cursor-pointer flex items-center justify-center transition-all duration-200",
                        {
                            "border-[#ffffff]": !isDisabled,
                            "border-gray-300": isDisabled,
                            "bg-white": checked,
                            "bg-transparent": !checked,
                            "opacity-50 cursor-not-allowed": isDisabled
                        }
                    )}
                >
                    {checked && (
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13.3334 4L6.00008 11.3333L2.66675 8"
                                stroke="#1431B5"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                </label>
            </div>
            <label htmlFor={id} className={cn("cursor-pointer", labelClassName)}>
                {label}
            </label>
        </div>
    );
});

CheckBoxGradient.displayName = 'CheckBoxGradient';

export default CheckBoxGradient;
